// extracted by mini-css-extract-plugin
module.exports =  {"icon":"ohF8DIxhsaSx7YpHmJuq"};